// extracted by mini-css-extract-plugin
export default {"toggleContainer":"lvGZCkIgJYL8mFeK_cFZ"};